<template>
  <g>
    <path
      d="M38 20c1.1 0 2 .899 2 2v16c0 1.1-.9 2-2 2H22c-1.1 0-2-.9-2-2V22c0-1.101.9-2 2-2zm0 1.5H22c-.271 0-.5.229-.5.5v16c0 .271.229.5.5.5h16c.271 0 .5-.229.5-.5V22c0-.271-.229-.5-.5-.5zm-5.09 1.494c.323-.323.853-.325 1.178 0l2.917 2.917c.326.325.326.854 0 1.179l-.717.716c-.84.84-2.17.893-3.072.156l-2.62 2.62 1.742 1.745c.16.158.246.368.246.59 0 .224-.088.433-.246.589l-2.532 2.533c-.766.77-1.827 1.21-2.912 1.21h-.012c-1.104 0-2.14-.43-2.92-1.21-.782-.78-1.212-1.818-1.212-2.923 0-1.104.43-2.142 1.21-2.923l2.533-2.533c.326-.324.855-.324 1.18 0l1.743 1.744 2.622-2.621c-.336-.41-.518-.917-.517-1.452.001-.612.24-1.187.673-1.62zm-5.827 6.435l-1.948 1.949c-.026.024-.052.05-.077.076-.457.479-.7 1.104-.685 1.762.015.659.286 1.272.762 1.727.476.457 1.1.723 1.76.683.66-.015 1.272-.285 1.728-.762l1.947-1.947-1.154-1.154-1.452 1.452c-.325.323-.854.325-1.179 0-.324-.325-.324-.855 0-1.18l1.452-1.452-1.154-1.154zm6.416-4.667l-.133.133c-.24.244-.239.64.005.882l.85.85c.123.122.254.182.45.187.165 0 .321-.067.438-.185l.128-.13-1.738-1.737z"
      transform="translate(-50 -95) translate(30 75)"
    />
  </g>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "SandboxIcon",
});
</script>
